import app from '$$app';
import log from '$$log';
import { api } from '$$store/api';

let templates = {};
const templatesLocale = (!GT.locales.supported[user.locale] || GT.locales.supported[user.locale].fallbackTemplates) ? GT.locales.fallback : user.locale;

function loadTemplates() {
  const t = log.time('pageLoad.model.templates');
  if (!app.config.mode.isLink) {
    api.get(`/templates/${templatesLocale}?${new Date().getTime()}`).then(response => {
      templates.parse(response.data);
      app.trigger('templates:init');
      t.end();
      app.checkInit('templates');
    }).catch(() => {
      templates.parse([]);
      app.trigger('templates:init');
      t.end();
      app.checkInit('templates');
    });
  } else {
    templates.parse([]);
    app.trigger('templates:init');
    t.end();
    app.checkInit('templates');
  }
}

if (!app.config.mode.isBase) {
  templates = new webix.DataCollection();
  const t = log.time('pageLoad.model.templates');
  t.end();
  app.checkInit('templates');
} else {
  templates = new webix.DataCollection();
  // loadTemplates();
}

app.on('app:start', () => {
  loadTemplates();
});

templates.getAllTemplates = function () {
  return this.serialize();
};

templates.getFirstTemplateIndex = function () {
  return this.baseTemplate[0].id;
};

templates.getBaseTemplates = function () {
  const baseTemplate = [];

  _.each(this.serialize(), template => {
    if (template.isPredefined) {
      let labelKey = template.nameKey;

      if (labelKey === 'default_template') {
        labelKey = 'default_template_recommended';
      }
      template.name = __(labelKey);
      baseTemplate.push(template);
    }
  });

  this.baseTemplate = webix.copy(baseTemplate);

  return baseTemplate;
};

templates.getUserTemplates = function () {
  if (this.userTemplate) {
    return this.userTemplate;
  }

  const userTemplate = [];

  _.each(this.serialize(), template => {
    if (template.owner_id) {
      userTemplate.push(template);
    }
  });

  this.baseTemplate = userTemplate;

  return userTemplate;
};

templates.addUserTemplate = function (gantt_id, icon, name, templateId, hasResources, settings = {}) {
  this.data.pull[templateId] = {
    gantt_id,
    name,
    icon,
    owner_id: GT.user.id,
    id: templateId,
    has_resources: hasResources,
  };

  if (settings.startProject) {
    this.data.pull[templateId].startProject = settings.startProject;
  }

  if (settings.workDays) {
    this.data.pull[templateId].workDays = settings.workDays;
  }

  this.data.order.push(templateId);
};

templates.deleteUsersTemplate = function (id) {
  api.delete(`/templates/${id}`).then(() => {
    templates.remove(id);
  });
};

templates.updateUsersTemplate = function (id, value) {
  const template = templates.getItem(id);

  api.put(`/templates/${id}`, { name: value, owner_id: template.owner_id }).then(() => {
    templates.updateItem(id, { name: value });
  });
};

app.on('getFirstTemplateId', callback => {
  callback(templates.getFirstId());
});

webix.dp(templates).attachEvent('onAfterSync', (obj, dataRaw, data) => {
  if (obj.status === 'delete' && data) {
    app.trigger('template:delete');
  }
});

export default templates;
